export default __webpack_public_path__ + "static/media/bannerCrisBarrosMobile.b85cc725.svg";